import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { Router } from '@angular/router'; // si tu veux rediriger

@Component({
  selector: 'app-se-connecter',
  standalone: true,
  templateUrl: './se-connecter.component.html',
  styleUrls: ['./se-connecter.component.css'],
  imports: [CommonModule, FormsModule],
})
export class SeConnecterComponent {
  loginForm = { email: '', password: '' };
  successMessage: string | null = null;
  errorMessage: string | null = null;

  constructor(private router: Router) {}

  async onLogin(event: Event) {
    event.preventDefault();
    this.successMessage = null;
    this.errorMessage = null;
    const auth = getAuth();
    const db = getFirestore();

    try {
      // 1. Authentification
      const userCredential = await signInWithEmailAndPassword(
        auth,
        this.loginForm.email,
        this.loginForm.password
      );
      const user = userCredential.user;

      // 2. Récupération du rôle en Firestore
      // Adapter le chemin selon ta structure, par exemple ici : collection 'users', doc ID = user.uid
      const userDocRef = doc(db, 'users', user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (!userDocSnap.exists()) {
        this.errorMessage = 'Compte non trouvé dans la base utilisateurs.';
        return;
      }

      const userData = userDocSnap.data();
      if (userData['role'] === 'admin') {
        this.successMessage = 'Connexion réussie !';
        setTimeout(() => this.router.navigate(['/dashboard']), 800); // <-- adapte ici !
      } else {
        this.errorMessage = 'Accès réservé aux administrateurs.';
      }
    } catch (error: any) {
      this.errorMessage = 'Identifiants incorrects ou problème de connexion.';
    }
  }
}
